import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetGrid';
import { InjectedPropsProvider, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { getWorksheetGridAdditionalDataProviderProps } from './providerProps';

let WorksheetGridAdditionalDataInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.worksheetGrid.additionalData);
  const setValue = (opts) => dispatch(actions.setAdditionalDataValue(opts));
  const submit = () => {};
  const providerData = {
    data,
    setValue,
    submit,
  };
  return (
    <InjectedPropsProvider
      getProviderProps={(consumerProps, modifiers) =>
        getWorksheetGridAdditionalDataProviderProps(consumerProps, providerData, modifiers)
      }
    >
      {children}
    </InjectedPropsProvider>
  );
};

WorksheetGridAdditionalDataInjectedPropsProvider = withInjectedProps(WorksheetGridAdditionalDataInjectedPropsProvider);

export { WorksheetGridAdditionalDataInjectedPropsProvider };
export default WorksheetGridAdditionalDataInjectedPropsProvider;
